import auth from './auth';
import mypage from './mypage';
import user from './user';
import refcode from './refcode';
import lecturer from './lecturer';
import file from './file';
import company from './company';
import crm from './crm';
import mailing from './mailing';
import project from './project';
import b2c from './b2c';
import schedule from './schedule';
import operate from './operate';
import bill from './bill';
import payment from './payment';
import outsourcing from './outsourcing';
import mailtemplate from './mailtemplate';
import management from './management';

export default {
  auth,
  mypage,
  user,
  refcode,
  lecturer,
  file,
  company,
  crm,
  mailing,
  project,
  b2c,
  schedule,
  operate,
  bill,
  payment,
  mailtemplate,
  outsourcing,
  management,
};
